import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import { Fields as PointsExperience } from 'models/PointsExperience'
import React from 'react'
import ToS from './TermsOfService'

const t = buildTranslate('points.configuration.edit.collect')

type Props = {
  title: string
  description: string
  pointsExperience?: PointsExperience
}

const TextInstructions: React.FC<Props> = ({
  title,
  description,
  pointsExperience,
}) => {
  return (
    <>
      <Text.BodyText4 bold tag="div" className="mb-m">
        {title}
      </Text.BodyText4>
      {description}
      <Switch condition={!!pointsExperience?.max_points_per_transaction}>
        <div className="mt-l">
          <Text.BodyText4 bold tag="div" className="mb-xs">
            {t('per_order_limit')}
          </Text.BodyText4>
          <Text.BodyText3>
            {t('restriction_per_purchase', {
              max_points_per_transaction:
                pointsExperience?.max_points_per_transaction,
              currency:
                pointsExperience?.currency_name_plural ||
                t('currency_fallback'),
            })}
          </Text.BodyText3>
        </div>
      </Switch>

      <ToS className="mt-l" />
    </>
  )
}

export default TextInstructions
